import React from 'react'
import { Box } from '@mui/material'
import { ButtonSeeker, IconSeeker, LoadingIconSeeker } from '@ui-seeker/core'
import { batch, useComputed } from '@preact/signals-react'
import { formData, formErrors } from '@signals'
import { selectedMappingId } from 'Pages/Admin/AdminMapping/@signals'
import { useAdminMappingForm } from 'Pages/Admin/AdminMapping/EditDrawer/@hooks'


export default function AdminMappingDrawerFooter() {

	const method = useComputed(() => formData.value?.method)
	const { submitPayload, isFormSubmitting } = useAdminMappingForm(method.value)
	const isValid = useComputed(() => Object.values(formErrors.value).every(e => e))

	return <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
		<ButtonSeeker variant="outlined" onClick={() => batch(() => {
			selectedMappingId.value = null
			formData.value = {}
		})}>
			Cancel
		</ButtonSeeker>
		<ButtonSeeker
			sx={{ minWidth: 103 }}
			startIcon={!isFormSubmitting ? <IconSeeker iconType="mui" icon="mdi:content-save-check"/> : <LoadingIconSeeker/>}
			onClick={submitPayload}
			disabled={!isValid.value}
		>
			Save
		</ButtonSeeker>
	</Box>
}